<template>
    <div :class="['zPaginator', {'zPaginator--disabled': pending}]">
        <iSpin size="large" fix v-if="pending"></iSpin>
        <slot></slot>
        <iPage v-if="paginator.total_results > 10"
               :current="paginator.page"
               :page-size="paginator.page_size"
               :total="paginator.total_results"
               :page-size-opts="[10, 50, 100, 1000]"
               show-total show-sizer @on-change="changePage" @on-page-size-change="changePageSize"></iPage>
    </div>
</template>




<script>
import {Page, Spin} from 'view-design';
import Vue from 'vue'

Vue.component('iPage', Page);
Vue.component('iSpin', Spin);

export default {
    name: 'zPaginator',
    props: {
        paginator: {
            type: Object,
            required: true,
            validator(value) {
                return (value.page && value.page_size && value.total_results) || value === null
            }
        },
        pending: {
            type: Boolean,
            required: true,
            default: false,
            validator(value) {
                return typeof value === 'boolean'
            }
        },
    },
    methods: {
        changePage(value) {
            this.$emit('changePage', value)
        },
        changePageSize(value) {
            this.$emit('changePageSize', value)
        }
    },
    created() {
        // console.log(this.paginator);
    },
}
</script>

<style lang="less" scoped>
.zPaginator {
    position: relative;
    .ivu-spin-fix {
        background: none;
    }
    .ivu-spin-large .ivu-spin-dot {
        width: 65px;
        height: 65px;
    }
}

.zPaginator--disabled {
    pointer-events: none;
    opacity: 0.5;
}

</style>